const BRAND_NAME = 'GfK';

export const DEFAULT_ERROR_MESSAGE = `The requested data for this page has failed to load.<br/> Please refresh your browser to try again. If this issue persists, please contact your ${BRAND_NAME} representative.`;

export const DEFAULT_SECTION_ERROR_MESSAGE = `The requested data for this section has failed to load.<br/> Please refresh your browser to try again. If this issue persists, please contact your ${BRAND_NAME} representative.`;

export const DEFAULT_ERROR_TITLE = `Unable to load page`;
